import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import seedCharities from '../data/charities.json'
import { api } from '../api/charities'

export const fetchCharities = createAsyncThunk('charities/fetch', () => api.getCharities())
export const fetchAdminCharities = createAsyncThunk('charities/fetchAdmin', () => api.getAdminCharities())

const charitiesSlice = createSlice({
  name: 'charities',
  initialState: { items: seedCharities, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCharities.pending, (state) => {
        state.loading = true
        state.error = null
        state.items = []
      })
      .addCase(fetchCharities.fulfilled, (state, action) => {
        state.loading = false
        state.items = action.payload
      })
      .addCase(fetchCharities.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(fetchAdminCharities.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAdminCharities.fulfilled, (state, action) => {
        state.loading = false
        state.items = action.payload
      })
      .addCase(fetchAdminCharities.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export default charitiesSlice.reducer
